const MONTHS = [
  'январе',
  'феврале',
  'марте',
  'апреле',
  'мае',
  'июне',
  'июле',
  'августе',
  'сентябре',
  'октябре',
  'ноябре',
  'декабре',
]

export default function monthPred(value: number) {
  const monthIndex = value - 1

  return monthIndex >= 0 && monthIndex <= 11 ? MONTHS[monthIndex] : ''
}
